import {Component, EventEmitter, Output} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {Marktplatz} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'common-ui-marktplatz',
  templateUrl: './marktplatz.component.html',
  styleUrls: ['./marktplatz.component.scss']
})
export class MarktplatzComponent extends FormBaseComponent<Marktplatz> {

  @Output()
  removeMarktplatzClicked = new EventEmitter<number>();

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService,
              protected readonly translateService: TranslateService) {
    super(messageService);
  }

  public removeMarktplatz(): void {
    this.removeMarktplatzClicked.emit(this.index);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      bezeichnung: [this.data.bezeichnung, [
        this.validatorService.required(),
        this.validatorService.maxLength(100)
      ]],
      identifikationsmerkmal: [this.data.identifikationsmerkmal, [
        this.validatorService.maxLength(100)
      ]]
    });
  }
}
